import { dealsStatus } from '../../../constants/general.constant';

export const getStatusColor = (status?: string) => {
  switch (status) {
    case dealsStatus.PendingReview:
      return 'warning';
    case dealsStatus.Approved:
    case dealsStatus.Closed:
      return 'success';
    case dealsStatus.Rejected:
    case dealsStatus.LostDeal:
      return 'error';
    case dealsStatus.New:
    default:
      return 'info';
  }
};
